<template>
  <el-dropdown
    split-button
    type="primary"
    size="mini"
    @click="onSaveAnswer()">
    保存修改
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item @click.native="passedRemain">通过未审核题目</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import QuestionReview from '@views/question-review/question-review.js'
import orderReviewValidate from '@views/order-review/mixins/order-review-validate.mixin.js'

export default {
  components: {},
  mixins: [orderReviewValidate],
  inject: ['page'],
  props: {
    id: [Number, String],
  },
  data () {
    return {}
  },
  computed: {
    ...Vuex.mapState({
      orderDetail: state => state.orderReview.orderDetail,
      // sjf 调整
      sjfOrderDetail: state => state.orderReview.sjfOrderDetail,
    }),
  },
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  methods: {
    async onSaveAnswer () {
      await this.checkAnswerBeforeSave()
      this.executeAnswerValidation()
    },
    executeAnswerValidation () {
      this.validateAnswer().then(() => {
        this.$confirm('保存修改的答案, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          let answers = QuestionReview().getRecoveryAnswers(this.page)
          request.common('updateOrderReviewAnswer', {
            id: this.id,
            templateresultjson: JSON.stringify(answers),
          }).then(() => {
            this.$alert('保存成功！', '提示', {type: 'success'})
          })
        }).catch(() => {
          this.$message.info('已取消保存')
        })
      })
    },
    passedRemain () {
      let validQuestions = QuestionReview().getValidQuestions()
      validQuestions.forEach(({id}) => {
        if (!QuestionReview().isReviewed(id)) {
          QuestionReview().reviewPassed(id)
        }
      })
      this.$message.success('已通过未审核题目')
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/OrderSaveAnswerButton.vue